import api from "@/api";

export default {
    /**
     * Lấy dữ liệu thống kê cho một không gian làm việc.
     * GET /workspaces/{workspaceId}/statistics
     */
    getWorkspaceStatistics(workspaceId,params) {
        return api.get(`/api/dashboard/workspaces/${workspaceId}/statistics`,{ params });
    },

    getData(params){
        return api.get(`/api/dashboard-tong-quan-cong-viec`,{ params });
    },

    getDetailedTasks(params){ 
        return api.get(`/api/dashboard-tong-quan-cong-viec/tasks`, { params });
    },
    
    getWorkspaceStackedChart(params){
        return  api.get(`/api/dashboard-tong-quan-cong-viec/theo-khong-gian-lam-viec`, { params });
    }
};